import { useEffect } from 'react';

const IPNoticePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#05070A] text-white">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-8">
          <a href="/" className="text-blue-400 hover:text-blue-300 transition-colors inline-flex items-center gap-2">
            ← Back to V&V
          </a>
        </div>
        
        <div className="prose prose-invert max-w-none">
          <h1 className="text-4xl font-bold mb-4">Intellectual Property Notice</h1>
          <div className="flex gap-6 text-gray-400 text-sm mb-8 pb-4 border-b border-gray-800">
            <span>Effective: 1 January 2026</span>
            <span>Governing law: Republic of Kenya</span>
          </div>
          
          <div className="bg-blue-500/10 border-l-4 border-blue-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-300">
              Vett & Venture Studio Limited (<strong className="text-white">"V&V"</strong>) has developed a proprietary industrial venture-building methodology over multiple years of research and operational deployment. This Notice sets out V&V's intellectual property rights in that methodology, its brand, and all associated tools, frameworks, and content.
            </p>
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Ownership Statement</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            All intellectual property on the V&V website and platform is the exclusive property of <strong className="text-white">Vett & Venture Studio Limited</strong>, a company incorporated in Kenya. This includes rights under copyright, trade mark, trade secret, and all applicable intellectual property laws of Kenya.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Proprietary Methodology and Frameworks</h2>
          
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 mb-4 flex gap-4">
            <div className="text-3xl">🏦</div>
            <div>
              <h3 className="text-lg font-semibold mb-2">The Problem Bank Framework</h3>
              <p className="text-gray-300">V&V's proprietary system for originating, categorising, scoring, and assigning industrial problems to Forge squads.</p>
            </div>
          </div>
          
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 mb-4 flex gap-4">
            <div className="text-3xl">📐</div>
            <div>
              <h3 className="text-lg font-semibold mb-2">The Scalar Criteria</h3>
              <p className="text-gray-300">V&V's proprietary multi-dimensional evaluation criteria used to assess whether an industrial problem qualifies for inclusion in the Problem Bank.</p>
            </div>
          </div>
          
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 mb-4 flex gap-4">
            <div className="text-3xl">📊</div>
            <div>
              <h3 className="text-lg font-semibold mb-2">The Grey Cost Diagnostic Methodology</h3>
              <p className="text-gray-300">V&V's proprietary framework for identifying, quantifying, and classifying hidden operational costs in industrial facilities.</p>
            </div>
          </div>
          
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 mb-4 flex gap-4">
            <div className="text-3xl">⚙️</div>
            <div>
              <h3 className="text-lg font-semibold mb-2">The Forge Programme Design</h3>
              <p className="text-gray-300">The complete design and operational structure of V&V's twelve-week industrial venture building programme.</p>
            </div>
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Brand and Trade Marks</h2>
          <ul className="list-disc pl-6 text-gray-300 space-y-1 mb-4">
            <li><strong className="text-white">VETT & VENTURE</strong> and <strong className="text-white">V&V</strong> — the studio's primary brand name and abbreviation</li>
            <li><strong className="text-white">THE FORGE</strong> — V&V's graduate venture building programme</li>
            <li><strong className="text-white">THE FOUNDRY</strong> — V&V's post-graduation venture support platform</li>
            <li><strong className="text-white">THE PROBLEM BANK</strong> — V&V's industrial problem origination system</li>
            <li><strong className="text-white">THE HUB</strong> — V&V's Fix-and-Deliver project marketplace</li>
            <li><strong className="text-white">PROCESS IS PROSPERITY</strong> — V&V's operating motto</li>
          </ul>
          
          <div className="bg-red-500/10 border-l-4 border-red-500 p-6 rounded-r-lg mt-8 mb-8">
            <strong className="text-red-400">Prohibited use:</strong> Forge alumni, anchor representatives, and Fix-and-Deliver clients may not reproduce, teach, or commercialise V&V's proprietary frameworks without a separate written licence.
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Contact</h2>
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6">
            <h3 className="text-lg font-semibold mb-2">IP and Legal Contact</h3>
            <p className="text-gray-300">Vett & Venture Studio Limited — Nairobi, Kenya</p>
            <p className="text-gray-300">Email: <a href="mailto:legal@vettandventure.com" className="text-blue-400 hover:underline">legal@vettandventure.com</a></p>
            <p className="text-gray-300">Phone: +254 745 665 732</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IPNoticePage;